import "./App.css";
import React, { useState, useRef } from "react";
import { FaApple, FaMagento } from "react-icons/fa";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { GetDevices } from "./controllers/devices-controller";
import listDevices from "./listDevices";
import {
  ApplyProfileBase,
  ApplyProfileRestrict,
  RemoveProfileBase,
  RemoveProfileRestric,
} from "./controllers/command-controller";
import AlertTitle from "@mui/material/AlertTitle";

function App() {
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [devices, setDevices] = useState(listDevices);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [isLocked, setIsLocked] = useState(false);

  async function sendProfileBase() {
    if (selectedDevice !== null) {
      await ApplyProfileBase(selectedDevice.uuid);
      alert("Dispositivo en perfil base");
    }
  }
  async function sendProfileLock() {
    if (selectedDevice !== null) {
      await RemoveProfileBase(selectedDevice.uuid);
      await ApplyProfileRestrict(selectedDevice.uuid);
      setIsLocked(true);
      alert("Dispositivo bloqueado");
    }
  }

  async function sendProfileUnlock() {
    if (selectedDevice !== null) {
      await RemoveProfileRestric(selectedDevice.uuid);
      await ApplyProfileBase(selectedDevice.uuid);
      alert("Dispositivo Desbloqueado");
    }
  }

  return (
    <div className="App">
      <div className="w-full h-screen flex">
        <section className="w-[12%] bg-[#f6f6f6]  h-screen flex flex-col items-center justify-between">
          <div className="w-full h-1/2 flex flex-col items-center">
            <h2 className="my-2 flex items-center w-full justify-around">
              <FaApple />
              IntegraTech MDM
            </h2>
            <ul className="w-3/4 h-[90%] py-4 flex flex-col gap-4">
              <li className="py-1 font-sans text-sm hover:bg-slate-400 cursor-pointer rounded-md">
                Dashboard
              </li>
              <li className="py-1 font-sans text-sm hover:bg-slate-400 cursor-pointer rounded-md">
                Locations
              </li>
              <li className="py-1 font-sans text-sm hover:bg-slate-400 cursor-pointer rounded-md">
                Devices Groups
              </li>
              <li className="cursor-pointer rounded-md bg-slate-400 py-1 font-sans text-sm">
                Devices
              </li>
            </ul>
          </div>
          <a
            href="www.mdm.cristopherdev.com/mdm/enroll"
            className="rounded border border-slate-500 w-[90%] py-2 mb-2 cursor-pointer"
          >
            enroller
          </a>
        </section>

        <section className="border-r border-slate-300 h-screen w-1/5 flex flex-col p-4 ">
          <Autocomplete
            options={devices}
            getOptionLabel={(option) => option.serial_number || ""}
            onChange={(event, newValue) => {
              setSelectedDevice(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Devices on MDM"
                variant="standard"
              />
            )}
          />
          <h2 className="font-sans ">Your Devices</h2>
        </section>

        <section className=" w-[63%]">
          <div className=" w-3/4 m-auto h-[10%] flex items-center">
            {selectedDevice != null && (
              <img
                className="h-3/4"
                src={selectedDevice.img}
                alt=""
                srcset=""
              />
            )}
            <h1 className="my-auto text-xl font-bold">
              {selectedDevice?.model || "No model found"}
            </h1>
          </div>

          <div className="m-auto flex p-2 flex-col w-3/4 items-start">
            <h2 className="text-lg font-sans font-semibold">Details</h2>
            <div class="grid grid-cols-3 grid-rows-2 gap-4 w-full h-1/4 m-auto p-2 font-light text-sm">
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">
                  Device Model
                </strong>
                <strong>{selectedDevice?.model || "No model found"}</strong>
              </div>
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">
                  Serial Number
                </strong>
                <strong>
                  {selectedDevice?.serial_number || "No serial found"}
                </strong>
              </div>
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">Color</strong>
                <strong>{selectedDevice?.color || "No serial found"}</strong>
              </div>
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">UUID</strong>
                <strong className="break-words max-w-full">
                  {selectedDevice?.uuid || "No uuid found"}
                </strong>
              </div>
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">Storage</strong>
                <strong>{selectedDevice?.storage || "No storage found"}</strong>
              </div>
              <div class="flex flex-col items-start p-2 ">
                <strong className="text-[12px] text-stone-400">Locked</strong>
                <div>
                  <Switch {...label} checked={isLocked} disabled />
                </div>
              </div>
            </div>
          </div>

          <div className="w-3/4 m-auto p-2 ">
            <Stack spacing={2} direction="row">
              <Button
                className={
                  selectedDevice != null
                    ? "!bg-blue-500"
                    : "!bg-slate-500  disabled"
                }
                onClick={sendProfileLock}
                variant="contained"
              >
                Lock
              </Button>
              <Button
                className={
                  selectedDevice != null
                    ? "!bg-blue-500"
                    : "!bg-slate-500  disabled"
                }
                onClick={sendProfileUnlock}
                variant="contained"
              >
                Unlock
              </Button>
              <Button
                className={
                  selectedDevice != null
                    ? "!bg-blue-500"
                    : "!bg-slate-500  disabled"
                }
                onClick={sendProfileBase}
                variant="contained"
              >
                Mode Basic
              </Button>
            </Stack>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
